<template>
    <span v-if="status" class="sb-badge" :class="`sb-badge--${tone}`" :title="status.name">
        <i v-if="status.icon" :class="[status.icon, 'sb-badge-icon']"></i>
        <span class="sb-badge-label">{{ status.name }}</span>
    </span>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    name: 'StatusBadge',
    props: {
        status: { type: Object, default: null }
    },
    computed: {
        tone() {
            if (!this.status) return 'neutral'
            if (this.status.final) return 'success'
            if (this.status.default) return 'warning'
            return 'primary'
        }
    }
}
</script>

<style scoped>
.sb-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 22px;
    padding: 0 10px;
    border-radius: 999px;
    font-size: 0.72rem;
    font-weight: 500;
    line-height: 1;
    letter-spacing: 0.01em;
    white-space: nowrap;
    box-sizing: border-box;
}

.sb-badge-icon {
    font-size: 0.7rem;
}

.sb-badge--success {
    background: rgba(16, 185, 129, 0.12);
    color: #047857;
}

.sb-badge--warning {
    background: rgba(245, 158, 11, 0.14);
    color: #b45309;
}

.sb-badge--primary {
    background: rgba(8, 145, 178, 0.12);
    color: #0e7490;
}

.sb-badge--neutral {
    background: #f1f5f9;
    color: #475569;
}
</style>
